/* eslint-disable @angular-eslint/no-input-rename */
import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { MemoryService } from 'src/app/services/memory.service';
import { RoleFormContext } from '../role-form-context';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'tr[app-role-rights-tr]',
    templateUrl: './role-rights-tr.component.html',
    styleUrls: ['./role-rights-tr.component.scss'],
    imports: [MatTableModule, NgClass, MatIconModule, MatCheckboxModule, FormsModule, ReactiveFormsModule]
})
export class RoleRightsTrComponent implements OnInit, OnChanges {
    /**
     * Indique si le formulaire est active
     */
    @Input()
    public disabled: boolean;

    /**
     * Contexte du formulaire (mode d'affichage ...).
     */
    public _context: RoleFormContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<RoleFormContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: RoleFormContext) {
        this._context$.next(value);
    }

    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    @Input()
    public rigthName: string;

    @Input()
    public roleRights: Rights[];


    @Input('readRights')
    public readControlId: Rights;

    @Input('createRights')
    public createControlId: Rights;

    @Input('editRights')
    public editControlId: Rights;

    @Input('deleteRights')
    public deleteControlId: Rights;

    @Output() public checkboxChangedValue: EventEmitter<Rights[]> = new EventEmitter<Rights[]>();

    // Controles
    public readControl: UntypedFormControl;
    public createControl: UntypedFormControl;
    public editControl: UntypedFormControl;
    public deleteControl: UntypedFormControl;

    public readControlAllowed: boolean = true;
    public createControlAllowed: boolean = true;
    public editControlAllowed: boolean = true;
    public deleteControlAllowed: boolean = true;

    constructor(
        public enumHelper: EnumHelper,
        private memoryService: MemoryService
    ) {}

    ngOnInit(): void {
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    ngOnChanges(): void {
        this.readControl = new UntypedFormControl(null);
        this.createControl = new UntypedFormControl(null);
        this.editControl = new UntypedFormControl(null);
        this.deleteControl = new UntypedFormControl(null);

        this.readControl.setValue(this.rightIsActive(this.readControlId));
        this.createControl.setValue(this.rightIsActive(this.createControlId));
        this.editControl.setValue(this.rightIsActive(this.editControlId));
        this.deleteControl.setValue(this.rightIsActive(this.deleteControlId));

        // Désactive les droits que l'utilisateur connecté ne possède pas
        if (this.memoryService.getConnectedUser().rights.findIndex((x) => x === this.readControlId) === -1) {
            this.readControlAllowed = false;
        }

        if (this.memoryService.getConnectedUser().rights.findIndex((x) => x === this.createControlId) === -1) {
            this.createControlAllowed = false;
        }

        if (this.memoryService.getConnectedUser().rights.findIndex((x) => x === this.editControlId) === -1) {
            this.editControlAllowed = false;
        }

        if (this.memoryService.getConnectedUser().rights.findIndex((x) => x === this.deleteControlId) === -1) {
            this.deleteControlAllowed = false;
        }
    }

    checkboxChanged(id: number, event) {
        if (event.checked) {
            this.roleRights.push(id);
        } else {
            this.roleRights = this.roleRights.filter((x) => x !== id);
        }

        this.checkboxChangedValue.emit(this.roleRights);
    }

    private rightIsActive(right: Rights): Boolean {
        const isActive = !!this.roleRights?.find((x) => x === right);
        return isActive;
    }
}
